import React from 'react';
import { Storage, translate } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { AUTHORITIES } from 'app/config/constants';
import { Button } from 'reactstrap';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';

import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { updateEntity as updateBank } from 'app/entities/bank/bank.reducer';

export function DocumentSetting() {
  const dispatch = useAppDispatch();
  const account = useAppSelector(state => state.authentication.account);
  const bankEntity = useAppSelector(state => state.bank.entity);

  const userRoleAccessList = useAppSelector(state => state.userManagement.userRoleAccessList);
  const isUserAuthorizedToEdit = userRoleAccessList.length === 0 || userRoleAccessList.some(role => role.bankId === bankEntity?.id);

  const [collapse, setCollapse] = React.useState(true);
  const handleCollapse = () => {
    setCollapse(prev => !prev);
  };

  React.useEffect(() => {
    if (bankEntity?.quotationEnabled !== undefined) {
      setQuotationCheck(bankEntity.quotationEnabled);
    }

    if (bankEntity?.invoiceEnabled !== undefined) {
      setInvoiceCheck(bankEntity.invoiceEnabled);
    }

    if (bankEntity?.localFormEnabled !== undefined) {
      setLocalFormCheck(bankEntity.localFormEnabled);
    }

    if (bankEntity?.poaFormEnabled !== undefined) {
      setPoaFormCheck(bankEntity.poaFormEnabled);
    }
  }, [bankEntity]);

  const [quotationCheck, setQuotationCheck] = React.useState(false);
  const handleQuotaionChange = () => {
    setQuotationCheck(prev => !prev);
  };

  const [invoiceCheck, setInvoiceCheck] = React.useState(false);
  const handleInvoiceCheck = () => {
    setInvoiceCheck(prev => !prev);
  };

  const [localFormCheck, setLocalFormCheck] = React.useState(false);
  const handleLocalFormCheck = () => {
    setLocalFormCheck(prev => !prev);
  };

  const [poaFormCheck, setPoaFormCheck] = React.useState(false);
  const handlePoaFormCheck = () => {
    setPoaFormCheck(prev => !prev);
  };

  const handleSubmit = () => {
    const updateDocumentSetting = {
      ...bankEntity,
      quotationEnabled: quotationCheck,
      invoiceEnabled: invoiceCheck,
      localFormEnabled: localFormCheck,
      poaFormEnabled: poaFormCheck,
    };
    dispatch(updateBank(updateDocumentSetting));
  };

  return (
    <div className="collapse-section">
      <Grid container className="align-items-center">
        <Grid item xs={10} sm={11} md={11.5}>
          <Typography variant="h5" component="div" data-cy="bankFeeHeading">
            {translate('comexApp.bank.details.documentSettings.title')}
          </Typography>
        </Grid>
        <Grid item xs={2} sm={1} md={0.5}>
          <IconButton aria-label="collapse" onClick={handleCollapse}>
            {collapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          </IconButton>
        </Grid>
      </Grid>
      <Collapse in={collapse}>
        <TableContainer className="my-3" sx={{ maxHeight: 320 }}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell style={{ borderBottom: 'none' }}>
                  <Grid container sx={{ alignItems: 'center' }}>
                    <Grid item sm={10} md={10}>
                      <Typography
                        variant="body1"
                        component={'div'}
                        style={{ fontWeight: 700 }}
                        align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                      >
                        {translate('comexApp.bank.details.documentSettings.quotation.title')}
                      </Typography>
                    </Grid>
                    <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                      <Tooltip
                        title={
                          quotationCheck
                            ? translate('comexApp.bank.details.documentSettings.quotation.tooltip.include')
                            : translate('comexApp.bank.details.documentSettings.quotation.tooltip.notInclude')
                        }
                      >
                        <Switch
                          checked={quotationCheck}
                          onChange={handleQuotaionChange}
                          name="quotationCheck"
                          disabled={
                            (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                              !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                            !isUserAuthorizedToEdit
                          }
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ borderBottom: 'none' }}>
                  <Grid container sx={{ alignItems: 'center' }}>
                    <Grid item sm={10} md={10}>
                      <Typography
                        variant="body1"
                        component={'div'}
                        style={{ fontWeight: 700 }}
                        align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                      >
                        {translate('comexApp.bank.details.documentSettings.invoice.title')}
                      </Typography>
                    </Grid>
                    <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                      <Tooltip
                        title={
                          invoiceCheck
                            ? translate('comexApp.bank.details.documentSettings.invoice.tooltip.include')
                            : translate('comexApp.bank.details.documentSettings.invoice.tooltip.notInclude')
                        }
                      >
                        <Switch
                          checked={invoiceCheck}
                          onChange={handleInvoiceCheck}
                          name="invoiceCheck"
                          disabled={
                            (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                              !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                            !isUserAuthorizedToEdit
                          }
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ borderBottom: 'none' }}>
                  <Grid container sx={{ alignItems: 'center' }}>
                    <Grid item sm={10} md={10}>
                      <Typography
                        variant="body1"
                        component={'div'}
                        style={{ fontWeight: 700 }}
                        align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                      >
                        {translate('comexApp.bank.details.documentSettings.localForm.title')}
                      </Typography>
                    </Grid>
                    <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                      <Tooltip
                        title={
                          localFormCheck
                            ? translate('comexApp.bank.details.documentSettings.localForm.tooltip.include')
                            : translate('comexApp.bank.details.documentSettings.localForm.tooltip.notInclude')
                        }
                      >
                        <Switch
                          checked={localFormCheck}
                          onChange={handleLocalFormCheck}
                          name="localFormCheck"
                          disabled={
                            (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                              !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                            !isUserAuthorizedToEdit
                          }
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ borderBottom: 'none' }}>
                  <Grid container sx={{ alignItems: 'center' }}>
                    <Grid item sm={10} md={10}>
                      <Typography
                        variant="body1"
                        component={'div'}
                        style={{ fontWeight: 700 }}
                        align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                      >
                        {translate('comexApp.bank.details.documentSettings.poaForm.title')}
                      </Typography>
                    </Grid>
                    <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                      <Tooltip
                        title={
                          poaFormCheck
                            ? translate('comexApp.bank.details.documentSettings.poaForm.tooltip.include')
                            : translate('comexApp.bank.details.documentSettings.poaForm.tooltip.notInclude')
                        }
                      >
                        <Switch
                          checked={poaFormCheck}
                          onChange={handlePoaFormCheck}
                          name="poaFormCheck"
                          disabled={
                            (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                              !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                            !isUserAuthorizedToEdit
                          }
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="submit"
            color="primary"
            onClick={handleSubmit}
            value={0}
            disabled={
              (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
              !isUserAuthorizedToEdit
            }
          >
            {translate('comexApp.bank.details.update')}
          </Button>
        </Box>
      </Collapse>
    </div>
  );
}
